import { useSelector } from "react-redux";
import { AppDispatch, RootState, useAppDispatch } from "../../../../../store";
import KatakomButton from "../../../../shared/KatakomButton";
import KatakomTable from "../../../../shared/KatakomTable";
import KatakomModal from "../../../../shared/KatakomModal";
import { useState } from "react";
import { Container, Row } from "../../../style";
import { deleteNepokretnostAdvokati } from "../../../../../store/CaseAdvokatiReducer";
import AssetModalComponentAdvokati from "./AssetModalComponentAdvokati";
import { mandatoryDocuments } from "../../../../../register/register";
import AssetModalComponentAdvokatiUverenjeOImovinskomStanju from "./AssetModalComponentAdvokatiUverenjeOImovinskomStanju";
import AssetModalComponentAdvokatGroup3and4 from "./AssetModalComponentAdvokatGroup3and4";

const AddAssetsAdvokati = () => {
    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
    const dispatch: AppDispatch = useAppDispatch();
    const nepokretnostKN = useSelector((state: RootState) => state.caseAdvokati.nepokretnostKN);
    const [editingNepokretnost, setEditingNepokretnost] = useState<any>(null);
    const vrstaIsprave = useSelector((state: RootState) => state.caseAdvokati.basicInfo.vrstaIspraveId);
    //@ts-ignore
    const grupaIsprave = mandatoryDocuments[String(vrstaIsprave)].groupType;

    const handleCloseModal = () => {
        setModalIsOpen(false);
    };

    const handleEditNepokretnost = (nepokretnost: any) => {
        setEditingNepokretnost(nepokretnost);
        setModalIsOpen(true);
    };

    const handleDeleteNepokretnost = (nepokretnost: any) => {
        dispatch(deleteNepokretnostAdvokati(nepokretnost.id));
    };

    const columns = [
        { label: "Ид", value: "id" },
        { label: "Врста непокретности", value: "tip" },
        { label: "Катастарска општина", value: "koNaziv" },
        { label: "Број парцеле", value: "brojParcele" },
        { label: "Подброј парцеле", value: "podBrojParcele" },
        { label: "Број објекта", value: "brojObjekta" },
        { label: "Број посебног дела објекта", value: "evidencijskiBroj" },
        { label: "Удео", value: "udeo" },
        { label: "", value: "edit" },
        { label: "", value: "delete" },
    ];

    return (
        <Container>
            <KatakomModal isOpen={modalIsOpen} setIsOpen={setModalIsOpen}>
                {vrstaIsprave == "6105" ? (
                    <AssetModalComponentAdvokatiUverenjeOImovinskomStanju
                        modalState={modalIsOpen}
                        closeModal={handleCloseModal}
                        nepokretnostId={editingNepokretnost ? editingNepokretnost.id : undefined}
                        setEditingNepokretnost={setEditingNepokretnost}
                    />
                ) : grupaIsprave === "3" || grupaIsprave === "4" ? (
                    <AssetModalComponentAdvokatGroup3and4
                        modalState={modalIsOpen}
                        closeModal={handleCloseModal}
                        nepokretnostId={editingNepokretnost ? editingNepokretnost.id : undefined}
                        setEditingNepokretnost={setEditingNepokretnost}
                    />
                ) : (
                    <AssetModalComponentAdvokati
                        modalState={modalIsOpen}
                        closeModal={handleCloseModal}
                        nepokretnostId={editingNepokretnost ? editingNepokretnost.id : undefined}
                        setEditingNepokretnost={setEditingNepokretnost}
                    />
                )}
            </KatakomModal>
            {nepokretnostKN.length !== 0 ? (
                <div style={{ margin: "15px" }}>
                    <KatakomTable
                        columns={columns}
                        data={nepokretnostKN}
                        onEdit={handleEditNepokretnost}
                        onDelete={handleDeleteNepokretnost}
                    />
                </div>
            ) : null}

            <Row style={{ display: "flex", justifyContent: "center" }}>
                <KatakomButton
                    label={"Додај непокретност"}
                    size="l"
                    onClick={() => {
                        setModalIsOpen(true);
                    }}
                ></KatakomButton>
            </Row>
        </Container>
    );
};

export default AddAssetsAdvokati;
